import React from 'react';
import {RWebShare} from 'react-web-share';
import {globalConfigurableData} from '../utils/globalConstant';
import {TEST_API_D24} from "../utils/apiUrl";
import {View} from "react-native";
import { Icon } from '@iconify/react';

const ShareEvent = ({eventName, eventId, isMulti}) => {
    return (
        <RWebShare
            data={{
                text:
                    'Hey, What do you think will happen? \n' +
                    eventName +
                    ' Click below link to join ',

                title: globalConfigurableData?.appName,
                url: TEST_API_D24 + "Event?eventId=" + eventId + "&isMulti=" + isMulti,
            }}>
            <View>
                <Icon 
                    icon="tabler:share-2"
                    style={{width: 24, height: 24}}
                    color={globalConfigurableData.primaryTextColor1}
                />
            </View>
        </RWebShare>
    );
};
export default ShareEvent;
